import React from 'react'
import PropTypes from 'prop-types'
import { Dropdown, Icon, themeColor } from '@elparking/components'

import styled from 'styled-components'
import Option from './Option'
import { injectIntl } from 'react-intl'

const Container = styled.div`
    width: 100%;
    height: 100%;
    max-width: 100%;
    margin: 0.4em 0;
    background: white;
    border-right: 1px solid ${themeColor('gray20')};
    display: inline-block;
`

const Selector = styled.div`
    border: 0px;
    width: 100%;
    height: 100%;
    position: relative;
    cursor: pointer;
`

const SelectorOption = styled.div`
    cursor: pointer;
    border-bottom: 1px solid ${themeColor('gray20')};
    color: ${themeColor('gray')};
    margin: 10px 10px 0px 10px;
    &:hover *, &:hover i:before {
        font-weight: 300px;
        color:  ${themeColor('main')};
    }
    &:last-child {
        border-bottom: 0;
    }
`

const SelectorOptionsBlock = styled.div`
    width: auto;
    padding: 0.5em;
    z-index: 10;
    position: absolute;
    border: 1px solid ${themeColor('gray20')};
    box-shadow: 0px 8px 24px 0px rgba(0.3, #000);
    background: ${themeColor('white')};
    margin-top: 1em;
    &:before {
        position: absolute;
        left: 16px;
        margin-top: -22px;
        content: ' ';
        border-left: 14px solid transparent;
        border-right: 14px solid transparent;
        border-bottom: 14px solid ${themeColor('gray20')};
    }
    &:after {
        position: absolute;
        left: 17px;
        top: 1px;
        margin-top: -13px;
        content: ' ';
        border-left: 13px solid transparent;
        border-right: 13px solid transparent;
        border-bottom: 13px solid ${themeColor('white')};
    }
`

const IconPlaceholder = styled.div`
    position: absolute;
    right: 0;
    line-height: 3em;
    font-size: 12px;
    color: ${themeColor('gray')};
    padding: 4px;
    background: white;
`

const SelectorPlaceholder = styled.div`
    height: 100%;
    padding: 0 10px;
    overflow: hidden;
    max-width: 100%;
    display: flex;
    align-items: center;
    outline: none;
`

class AirportSelector extends React.Component {
    static propTypes = {
        options: PropTypes.arrayOf(PropTypes.shape({
            icon: PropTypes.string,
            label: PropTypes.string,
            value: PropTypes.string,
        })),
        onChange: PropTypes.func,
        selected: PropTypes.string,
    }

    static defaultProps = {
        onChange: () => {},
    }

    render () {
        const { options, onChange, selected } = this.props
        return (
            <Dropdown
              renderSelected={(option) => <Option
                color='main'
                dataTest='parking-search-form-places-selector-selected'
                icon={option.icon}
                iconSize={option.iconSize}
                text={option.label}
              />}
              renderOption={(option) => <Option
                color={selected === option.value ? 'main' : 'gray'}
                dataTest={option.dataTest}
                icon={option.icon}
                iconSize={option.iconSize}
                text={option.label}
              />}
              containerElement={Container}
              selectorElement={Selector}
              selectorOptionElement={SelectorOption}
              selectorOptionsBlockElement={SelectorOptionsBlock}
              selectorPlaceholderElement={SelectorPlaceholder}
              iconPlaceholderElement={() => <IconPlaceholder><Icon type='arrow-down' size='xxSmall' color='inherit' /></IconPlaceholder>}
              options={options}
              value={selected}
              onChange={onChange}
              onlyDesktop
            />
        )
    }
}

export default injectIntl(AirportSelector)
